var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "notice",
      class: _vm.noticeClass(),
      attrs: { role: "status" }
    },
    [
      _vm.header
        ? _c("div", { staticClass: "notice__title" }, [
            _vm._v(" " + _vm._s(_vm.header) + " ")
          ])
        : _vm._e(),
      _vm.message
        ? _c("p", { class: { "no-margin-top": !_vm.header } }, [
            _vm._v(" " + _vm._s(_vm.message) + " ")
          ])
        : _vm._e(),
      _vm.secondaryMessage
        ? _c("p", [_vm._v(" " + _vm._s(_vm.secondaryMessage) + " ")])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }